import React, { useMemo } from "react";
import { View, StyleSheet } from "react-native";
import NtText from "./NtText";
import { useTheme } from "../context/ThemeContext";

/**
 * KPI/stat card — label + big number + optional delta/trend line.
 *
 *   <NtStatCard label="Active Calls" value={18} delta="↑ 4 vs 1h ago" trend="up" />
 *   <NtStatCard label="Offline > 1h" value={3} delta="Needs attention" trend="down" />
 */
function NtStatCard({ label, value, delta, trend, style }) {
  const { theme } = useTheme();
  const styles = useMemo(() => makeStyles(theme), [theme]);

  return (
    <View style={[styles.wrap, style]}>
      {label ? <NtText style={styles.label}>{label}</NtText> : null}
      {value !== undefined && value !== null ? (
        <NtText style={styles.value}>{String(value)}</NtText>
      ) : null}
      {delta ? (
        <NtText
          style={[
            styles.delta,
            trend === "up" && { color: theme.green },
            trend === "down" && { color: theme.red },
          ]}
        >
          {delta}
        </NtText>
      ) : null}
    </View>
  );
}

const makeStyles = (t) =>
  StyleSheet.create({
    wrap: {
      flex: 1,
      minWidth: 120,
      backgroundColor: t.surface2,
      borderWidth: 1,
      borderColor: t.borderSoft,
      borderRadius: t.radius,
      paddingVertical: 14,
      paddingHorizontal: 16,
    },
    label: { fontSize: 11, color: t.textDim, fontWeight: "500" },
    value: {
      fontSize: 22,
      fontWeight: "700",
      color: t.text,
      marginTop: 4,
      letterSpacing: -0.4,
    },
    delta: { fontSize: 11, marginTop: 2, color: t.textDim },
  });

export default NtStatCard;
